import React from "react";
import CartLayout from "../components/cart/CartLayout";
import Footer from "../components/shared/footer/Footer";
import Header from "../components/shared/header/Header";

const Cart = () => {
  return (
    <>
      <Header />
      <CartLayout />
      <Footer />
    </>
  );
};

export default Cart;
